/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feature_UnavailableInputs */

const en_feature_unavailable = /** @type {(inputs: Feature_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature unavailable`)
};

const nl_feature_unavailable = /** @type {(inputs: Feature_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functie niet beschikbaar`)
};

/**
* | output |
* | --- |
* | "Feature unavailable" |
*
* @param {Feature_UnavailableInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const feature_unavailable = /** @type {((inputs?: Feature_UnavailableInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_UnavailableInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_feature_unavailable(inputs)
	return en_feature_unavailable(inputs)
});